module.exports = __webpack_public_path__ + "media/images/social-icons/link-0c87ce2ce03f93d2a45d11d105e2dfd8.svg";